.content {
  width: 100%;
  user-select: none;
}
